import React, { Component } from "react";
import { observer } from "mobx-react";
import { Checkbox, Col, Form, Row, Select, Tooltip } from "antd";
import { formLayout } from "../../../../../utilities";
import WizardFormButtons from "../../../../ui/forms/WizardFormButtons";

/**
 * Page from the form wizard with additional property questions/options.
 */
@observer
class PropertyOptionsInfo extends Component {
	static propTypes = {};

	render() {
		const { clientData } = this.props.service;

		return (
			<Form
				{...formLayout}
				onFinish={this.props.onFinish}
				colon={false}
				initialValues={{
					terrorism: clientData.terrorism || false,
					excess: clientData.excess,
				}}
			>
				<Row>
					<Col xs={12}>
						<h4 className="my-5">
							Do you require any of these additional cover options?
						</h4>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 6, offset: 0 }}>
						<Tooltip title="Terrorism insurance is insurance purchased by property owners to cover their potential losses and liabilities that might occur due to terrorist activities">
							<Form.Item
								name="terrorism"
								valuePropName="checked"
								label="Terrorism Cover"
							>
								<Checkbox></Checkbox>
							</Form.Item>
						</Tooltip>
					</Col>
				</Row>
				<Row>
					<Col md={{ span: 6, offset: 0 }}>
						<Tooltip title="This is in addtion to the compulsory excess of £250">
							<Form.Item label="Voluntary Excess" name="excess">
								<Select>
									<Select.Option value={150}>£150</Select.Option>
									<Select.Option value={250}>£250</Select.Option>
									<Select.Option value={350}>£350</Select.Option>
									<Select.Option value={450}>£450</Select.Option>
									<Select.Option value={550}>£550</Select.Option>
								</Select>
							</Form.Item>
						</Tooltip>
					</Col>
				</Row>
				<Row>
					<Col xs={24} className="d-flex">
						<WizardFormButtons tabs={this.props.tabs} />
					</Col>
				</Row>
			</Form>
		);
	}
}

export default PropertyOptionsInfo;
